import type SVGProps from '~/components/icons/svg-props'

export type ArrowRightIconProps = SVGProps & {
  variant?: 'outlined' | 'filled'
}

export default function ArrowRightIcon(props: ArrowRightIconProps) {
  const { variant, width = '24', height = '24', ...rest } = props
  return variant === 'filled' ? (
    <ArrowRightIconFilled width={width} height={height} {...rest} />
  ) : (
    <ArrowRightIconOutlined width={width} height={height} {...rest} />
  )
}

function ArrowRightIconOutlined(props: SVGProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.20954 6.14446C9.46113 5.9288 9.83991 5.95794 10.0556 6.20954L14.8556 11.8095C15.0481 12.0342 15.0481 12.3658 14.8556 12.5905L10.0556 18.1905C9.83991 18.4421 9.46113 18.4712 9.20954 18.2555C8.95794 18.0399 8.9288 17.6611 9.14446 17.4095L13.6098 12.2L9.14446 6.99048C8.9288 6.73889 8.95794 6.36011 9.20954 6.14446Z"
        fill="currentColor"
      />
    </svg>
  )
}

function ArrowRightIconFilled(props: SVGProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.20954 6.14446C9.46113 5.9288 9.83991 5.95794 10.0556 6.20954L14.8556 11.8095C15.0481 12.0342 15.0481 12.3658 14.8556 12.5905L10.0556 18.1905C9.83991 18.4421 9.46113 18.4712 9.20954 18.2555C8.95794 18.0399 8.9288 17.6611 9.14446 17.4095L13.6098 12.2L9.14446 6.99048C8.9288 6.73889 8.95794 6.36011 9.20954 6.14446Z"
        fill="currentColor"
      />
    </svg>
  )
}
